import React, { useState } from "react";
import logo from "../assets/images/Logo.png";
import { Alert, Button, Col, Form, Input, Row, Spin } from "antd";
import {
  UserOutlined,
  LockOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { toLogin } from "../apis/actions/auth.actions";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../apis/store";

export const LoginPage: React.FC = () => {
  const [displayError, setDisplayError] = useState<string>("");
  const [form] = Form.useForm();
  const [cookies, setCookie] = useCookies(["apiKey"]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const onFinish = async () => {
    setDisplayError("");
    try {
      await form.validateFields();
      setLoading(true);
      const success = (await dispatch(
        toLogin({
          login: form.getFieldValue("username"),
          password: form.getFieldValue("password"),
        })
      )) as any;
      const login = success?.payload?.data?.result;

      if (login?.code === 200) {
        setCookie("apiKey", Object.values(login)[0]);

        setTimeout(() => {
          navigate("/dashboard");
        }, 500);
      } else {
        setDisplayError(
          login?.message
            ? "بيانات الدخول غير صحيحة"
            : "الرجاء الإنتظار قليلا ..."
        );
        setLoading(false);
      }
      setLoading(false);
    } catch (error) {}
  };
  return (
    <div className="login-container">
      {/* Left side with background image and logo */}
      <div className="ghaith--background-section">
        <div className="logo">
          <img src={logo} alt="Logo" />
        </div>
      </div>

      {/* Right side with login form */}
      <div className="login-section">
        <div className="login-form">
          {displayError !== "" && (
            <Row gutter={16} className="">
              <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                <Alert
                  message={
                    <div className="ghaith--login-error-message">
                      <span>{displayError}</span>
                    </div>
                  }
                  type="error"
                  onClose={() => setDisplayError("")}
                />
              </Col>
            </Row>
          )}
          <h2>تسجيل الدخول</h2>
          <Form form={form} onChange={() => setDisplayError("")}>
            <div className="form-group">
              <Form.Item
                label=""
                name="username"
                rules={[
                  {
                    required: true,
                    message: "من فضلك ادخل بريدك الالكتروني",
                  },
                ]}
              >
                <Input
                  className="ghaith--input-login"
                  type="text"
                  placeholder="اسم المستخدم"
                  prefix={<UserOutlined />}
                  size="large"
                />
              </Form.Item>
            </div>
            <div className="form-group">
              <Form.Item
                label=""
                name="password"
                rules={[
                  {
                    required: true,
                    message: "من فضلك ادخل كلمة المرور",
                  },
                ]}
              >
                <Input.Password
                  className="ghaith--input-login"
                  size="large"
                  type="password"
                  placeholder="كلمة المرور"
                  prefix={<LockOutlined size={18} />}
                />
              </Form.Item>
            </div>
            <Button
              onClick={onFinish}
              className="Login-button"
              type="primary"
              size="large"
              disabled={loading}
            >
              <ArrowLeftOutlined />
              {loading ? <Spin size="small" /> : "تسجيل الدخول"}{" "}
            </Button>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
